export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "synopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis', parent: 'boltHome' },
	{ id: 'boltGallery', getter: () => import(/* webpackChunkName: "gallery" */ 'components/bolt/gallery/gallery'), component: 'gallery', parent: 'boltHome' },
	{ id: 'partner', getter: () => import(/* webpackChunkName: "imageTiles" */ 'components/bolt/imageTiles/imageTiles'), component: 'imageTiles', parent: 'boltHome' }
];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
